import { supabase } from '../lib/supabase';

const isSchemaError = (error) => {
  if (!error) return false;
  if (error?.code && typeof error?.code === 'string') {
    const errorClass = error?.code?.substring(0, 2);
    if (errorClass === '42' || errorClass === '08') return true;
    if (errorClass === '23') return false;
  }
  if (error?.message) {
    const schemaErrorPatterns = [
      /relation.*does not exist/i,
      /column.*does not exist/i,
      /function.*does not exist/i,
    ];
    return schemaErrorPatterns?.some(pattern => pattern?.test(error?.message));
  }
  return false;
};

export const dashboardService = {
  async getStatusCounts() {
    try {
      const statuses = [
        'recepcionado',
        'inspeccionado',
        'cotizando',
        'aprobado',
        'enproceso',
        'terminado',
        'entregado',
        'cancelado'
      ];

      const counts = await Promise.all(
        statuses?.map(async (status) => {
          const { count, error } = await supabase?.from('work_orders')?.select('*', { count: 'exact', head: true })?.eq('estado_ot', status);

          if (error) {
            if (isSchemaError(error)) {
              console.error('Schema error:', error?.message);
              throw error;
            }
            console.log(`Error counting ${status}:`, error?.message);
            return { status, count: 0 };
          }

          return { status, count: count || 0 };
        })
      );

      return counts;
    } catch (error) {
      console.error('Failed to get status counts:', error);
      throw error;
    }
  },

  async getRecentActivities(limit = 10) {
    try {
      const { data, error } = await supabase?.from('audit_logs')?.select('*')?.order('timestamp', { ascending: false })?.limit(limit);

      if (error) {
        if (isSchemaError(error)) {
          console.error('Schema error:', error?.message);
          throw error;
        }
        if (error?.code === 'PGRST116') return [];
        console.log('Error fetching activities:', error?.message);
        return [];
      }

      return data || [];
    } catch (error) {
      console.error('Failed to fetch recent activities:', error);
      throw error;
    }
  }
};